module.exports = __webpack_public_path__ + "img/logo-azul-sem-fundo.da1db747.png";